<template>
    <div>
        <div class="container">
            <p class="number">
                선택가능갯수 <span>{{ filtersVisible.length }}</span
                ><span class="total-count">/10</span>
            </p>
            <div class="table bb-0 table_custom">
                <div class="table-col">
                    <div class="table-head">
                        <span>1차</span>
                    </div>
                    <div class="table-body">
                        <ul>
                            <li v-for="(i, e) in primaryList" :key="e" :class="`${`${primarySelected.id}` === `${i.id}` ? 'active' : ''}`" @click="setSelectedPrimary(i)">
                                {{ i.text }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="table-col">
                    <div class="table-head">
                        <span>2차</span>
                    </div>
                    <div class="table-body">
                        <ul>
                            <li v-for="(j, e) in secondaryList" :key="e" :class="`${`${secondarySelected.id}` === `${j.id}` ? 'active' : ''}`" @click="setSelectedSecondary(j)">
                                {{ j.text }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="table-col">
                    <div class="table-head">
                        <span>3차</span>
                    </div>
                    <div class="table-body">
                        <ul>
                            <li v-for="(k, e) in tertiaryList" :key="e" :class="`${findSelectedThird(k.id) ? 'active' : ''}`" @click="setSelectedTertiary(k)">
                                {{ k.text }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="setting-btm bt-1">
            <div class="container">
                <div class="sub-otr mb-32">
                    <h4 class="sub-heading mb-0">선택한 직종</h4>
                </div>

                <Tag class="p-mr-3 p-mb-2" v-for="(i, e) in filtersVisible" :key="e">
                    <div class="flex align-items-center gap-2">
                        <span class="text-base">{{ i }}</span>
                        <i class="pi pi-times text-xs" @click="removeFilter(i, $event)"></i>
                    </div>
                </Tag>
                <!-- <div class="fixed-btn-otr">
                    <Button label="설정하기" icon="pi pi-check" @click="submitFilter" />
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { onBeforeMount, ref, watch } from 'vue';
import { occupationService } from '@/service/API/JobSelection.js';
export default {
    emits: ['submit', 'selected_filters'],
    setup(props, { emit }) {
        const primaryList = ref([]);
        const secondaryList = ref([]);
        const tertiaryList = ref([]);
        const primarySelected = ref({});
        const secondarySelected = ref({});
        const tertiarySelected = ref([]);
        const totalFilters = ref([]);
        const filtersVisible = ref([]);
        const Backup = ref([]);

        onBeforeMount(() => {
            getPrimaryList();
        });

        // adding filters which are visible to the user
        watch(
            () => totalFilters.value,
            (val) => {
                filtersVisible.value = [];
                // console.log(val, "changed");
                val.forEach((ele) => {
                    filtersVisible.value.push(...ele.name);
                });
                // console.log(store.state.filtersVisible, "check value after add");
                // setFiltervalue
                // filtervalue = filtersVisible;
                // console.log(filtervalue);
            },
            { deep: true }
        );

        const getPrimaryList = async () => {
            let res = await occupationService.occupationPrimary();
            primaryList.value = res.data;
        };

        // Getting 2nd list when selecting from 1st list
        const setSelectedPrimary = async (item) => {
            primarySelected.value = item;
            let res = await occupationService.occupationSecondary(primarySelected.value.id);
            tertiaryList.value = [];
            tertiarySelected.value = [];
            secondarySelected.value = {};
            secondaryList.value = res.data;
            secondaryList.value.unshift({
                id: 'second',
                '1st_level_id': primarySelected.value.id,
                // text: `all of ${primarySelected.value.text}`,
                text: `${primarySelected.value.text} 전체`,
            });
        };

        // methods calls when selecting any item from 2nd row
        const setSelectedSecondary = async (item) => {
            secondarySelected.value = item;
            tertiaryList.value = [];
            tertiarySelected.value = [];
            if (Object.values(secondarySelected.value).length > 0) {
                // if user selects any option except "all of second(1st item on the list)" in the list
                if (secondarySelected.value.id != 'second') {
                    // fetch third row data
                    let res = await occupationService.occupationTertiary(secondarySelected.value.id);
                    // setting third row list data and adding all of third at the top
                    tertiaryList.value = res.data;
                    tertiaryList.value.unshift({
                        id: 'third',
                        '2nd_level_id': secondarySelected.value.id,
                        // text: `all of ${secondarySelected.value.text}`,
                        text: `${secondarySelected.value.text} 전체`,
                    });
                    //
                    // console.log(primarySelected.value.id);
                    var presentId = totalFilters.value.find((ele) => ele.occupation_first === primarySelected.value.id);
                    // console.log(presentId);
                    if (presentId !== undefined && presentId.occupation_second.length <= 0) {
                        let removedItem = totalFilters.value.splice(
                            totalFilters.value.findIndex((item) => item.occupation_first === presentId.occupation_first),
                            1
                        );

                        console.log('removed item', removedItem);
                    }
                } else {
                    // if user selects "all of second(1st item on the list)" in the list
                    if (filtersVisible.value.length >= 10) {
                        return;
                    } else {
                        tertiaryList.value = [];
                        tertiarySelected.value = [];
                        console.log(
                            'searched Id',
                            totalFilters.value.findIndex((ele) => ele.occupation_first === primarySelected.value.id)
                        );
                        // if there is no other item from 2nd list primarily selected
                        if (totalFilters.value.findIndex((ele) => ele.occupation_first === primarySelected.value.id) == -1) {
                            totalFilters.value.push({
                                occupation_first: primarySelected.value.id,
                                occupation_second: "",
                                name: [secondarySelected.value.text],
                            });
                            console.log('no previous add ... adding', totalFilters.value);
                        }
                        // if other item from 2nd list primarily selected
                        else {
                            console.log('checking with', primarySelected.value.id);
                            let filteredArr = [
                                ...totalFilters.value.filter((res) => {
                                    return res.occupation_first != primarySelected.value.id;
                                }),
                            ];
                            totalFilters.value = [];
                            // filter out previously selected
                            totalFilters.value.push(...filteredArr, {
                                occupation_first: primarySelected.value.id,
                                occupation_second: "",
                                name: [secondarySelected.value.text],
                            });
                            console.log(totalFilters.value);
                        }
                    }
                }
            }
        };

        // // Method calls when selecting any item from 3rd row list
        const setSelectedTertiary = (item) => {
            let findId = tertiarySelected.value.findIndex((x) => x.id === item.id);
            if (findId != -1 || filtersVisible.value.length >= 10) {
                // tertiarySelected.value.splice(findId, 1);
                return;
            } else {
                tertiarySelected.value.push(item);
                if (item.id != 'third') {
                    var isPresentVal = totalFilters.value.find((ele) => ele.occupation_second === secondarySelected.value.id);
                    // console.log("if present", isPresentVal);
                    if (isPresentVal == undefined) {
                        totalFilters.value.push({
                            occupation_first: primarySelected.value.id,
                            occupation_second: secondarySelected.value.id,
                            occupation_third: [item.id],
                            name: [item.text],
                        });
                    } else {
                        let allthirdId = tertiarySelected.value.findIndex((res) => res.id === 'third');
                        if (allthirdId > -1) {
                            tertiarySelected.value.splice(allthirdId, 1);
                        }
                        if (isPresentVal.name.includes(`${secondarySelected.value.text} 전체`)) {
                            // console.log("here here");
                            isPresentVal.name.splice(
                                isPresentVal.name.findIndex((res) => res.includes(`${secondarySelected.value.text} 전체`)),
                                1
                            );
                        }
                        if (!isPresentVal.occupation_third.includes(item.id)) {
                            isPresentVal.occupation_third.push(item.id);
                            isPresentVal.name.push(item.text);
                        }
                    }
                } else {
                    if (totalFilters.value.findIndex((ele) => ele.occupation_second === secondarySelected.value.id) == -1) {
                        totalFilters.value.push({
                            occupation_first: primarySelected.value.id,
                            occupation_second: secondarySelected.value.id,
                            occupation_third: [],
                            name: [item.text],
                        });
                        // console.log("no previous add ... adding", totalFilters.value);
                    } else {
                        tertiarySelected.value = [];
                        tertiarySelected.value.push({
                            id: 'third',
                            '2nd_level_id': secondarySelected.value.id,
                            // text: `all of ${secondarySelected.value.text}`,
                            text: `${secondarySelected.value.text} 전체`,
                        });
                        totalFilters.value.forEach((x) => {
                            if (x.occupation_second === secondarySelected.value.id) {
                                x.occupation_third = [];
                                x.name.splice(0, x.name.length, item.text);
                            }
                        });
                    }
                }
            }
            console.log(totalFilters.value);
        };

        const findSelectedThird = (id) => {
            if (tertiarySelected.value.findIndex((ele) => String(ele.id) === `${id}`) !== -1) {
                return true;
            } else {
                return false;
            }
        };

        // removing added filters which are visible to the user( will update the totalFilters array)
        const removeFilter = (itemToRemove, e) => {
            console.log('clickde');
            e.preventDefault();
            totalFilters.value.forEach((wholeItem, wholeId) => {
                console.log(wholeItem);
                if (wholeItem.name.includes(itemToRemove)) {
                    console.log(wholeItem.occupation_second);
                    // primarySelected.value = {};
                    // secondarySelected.value = {};
                    // tertiarySelected.value = [];
                    if ((Array.isArray(wholeItem.occupation_second) && wholeItem.occupation_second.length == 0) || wholeItem.occupation_third.length == 1) {
                        // let filterArr = totalFilters.value.filter(
                        //   (res) => !res.name.includes(itemToRemove)
                        // );
                        // console.log(filterArr);
                        totalFilters.value.splice(wholeId, 1);
                    } else {
                        let itemId = wholeItem.name.findIndex((ocu) => ocu === itemToRemove);
                        console.log(itemId);
                        wholeItem.name.splice(itemId, 1);
                        wholeItem.occupation_third.splice(itemId, 1);
                    }
                }
            });
            submitFilter
        };

        const submitFilter = () => {
            Backup.value = [];
            let finalData = totalFilters.value.map(({ name, ...rest }) => {
                console.log(name);
                return rest;
            });
            Backup.value.push(...finalData);
            emit('submit', Backup.value);
            emit('selected_filters', filtersVisible.value);
            // store.state.totalFilterState = toRaw(Backup.value);
            // store.state.filtersVisibleState = filtersVisible.value;
            // console.log(store.state.totalFilterState);
        };

        const refreshAll = (e) => {
            e.preventDefault();
            secondaryList.value = [];
            tertiaryList.value = [];
            totalFilters.value = [];
            filtersVisible.value = [];
            primarySelected.value = {};
            secondarySelected.value = {};
            tertiarySelected.value = [];
        };

        return {
            primaryList,
            primarySelected,
            secondaryList,
            secondarySelected,
            tertiaryList,
            filtersVisible,
            totalFilters,
            //   // getFilterName,
            setSelectedPrimary,
            setSelectedSecondary,
            setSelectedTertiary,
            findSelectedThird,
            removeFilter,
            refreshAll,
            submitFilter,
        };
    },
};
</script>
<style scoped>
.table.bb-0 {
    display: flex;
}
.table-col {
    min-width: 33.33%;
    border-left: 1px solid lightgrey;
    padding-left: 15px;
    border-bottom: 1px solid lightgrey;
}
.table-body ul {
    padding: 0;
    list-style: none;
}
.table-body li {
    margin-bottom: 10px;
    cursor: pointer;
}
.table-col:first-child {
    border-left: 0;
    padding: 0;
}
.table-head {
    border-bottom: 1px solid lightgrey;
    border-top: 1px solid lightgrey;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-left: -15px;
    text-align: center;
}
.table_custom {
    margin-bottom: 15px;
}
</style>
